<template>
    <svg 
        :width="width" 
        :height="height" 
        viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"
    >
    <path d="M10 7L7 10M10 7L7 4M10 7L3 7" :stroke="iconColor" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
</template>
  
<script>
export default {
  props: {
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    iconColor: {
      type: String,
      default: "currentColor",
    },
  },
};
</script>